"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNetworkhealthPageActionsApi = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _sliReactMetrics = require("@cvent/sli-react-metrics");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ------------------------------------------------------------------------------------
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This client was automatically generated. ** Do Not Edit **
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ------------------------------------------------------------------------------------
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
/**
 * This hook exposes a typed api with functions from the application's tracking plan.
 * Internally, each function uses the usePageActions API to track actions and forward
 * them to the reporters that were installed during the Metrics initialization in your
 * application's main entry point component.
 *
 * Note: This is the recommended way of tracking/measuring actions as it allows you to
 * register base properties during the metrics' client initialization, which will be included
 * automatically to every action whenever they are executed by your instrumentation code
 *
 *
 * How to use it:
 *
 * `const { acqSignupCompleted } = useNetworkhealthPageActionsApi();`
 *
 *  // Somewhere in your application you can use this function to track this action
 * `acqSignupCompleted({ userId, email, accountName });`
 *
 * // If you want to track this action as an error you can do it with this piece of code below
 *  `acqSignupCompleted({ userId, email, error: '500 Error........' });`
 *
 * // If you want to track this action as an expected error you can do it with this piece of code below
 *  `acqSignupCompleted({ userId, email, expected_error: 'This email address is already associated with an existing account.' });`
 *
 * @returns AnalyticsApi
 */
var useNetworkhealthPageActionsApi = exports.useNetworkhealthPageActionsApi = function useNetworkhealthPageActionsApi() {
  var _usePageActions = (0, _sliReactMetrics.usePageActions)(),
    trackAction = _usePageActions.trackAction,
    getBaseProps = _usePageActions.getBaseProps;
  var _ref = getBaseProps() || {},
    trackingPlanName = _ref.trackingPlanName;
  /**
   * this action tracks the users who hover over network health indicator icon in order to view network health tooltip
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio user views network health tooltip
   * downstreamName: user views network health tooltip
   * owner         : incognito
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when user hovers over network health indicator icon to view network health tooltip
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {UserViewsNetworkHealthTooltip} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var userViewsNetworkHealthTooltip = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio user views network health tooltip'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'user views network health tooltip'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  return {
    userViewsNetworkHealthTooltip: userViewsNetworkHealthTooltip
  };
};